import React, { useEffect } from "react";
import "./login.scss";
import FooterV2 from "../../components/FooterV2/FooterV2";
import BlinkingDots from "../../Animations/BlinkingDots/BlinkingDots";
import { Link } from "react-router-dom";
import { designAssistantLoginURL } from "../../components/helpers/constant-words";
import useTheme from "../../components/useTheme/useTheme";

const Login = () => {
  const { theme } = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <BlinkingDots />
      <main className="user_login_container">
        <section className="login_sec1">
          <div className="my_container">
            <div className="text_container">
              <h2 className="sub_title">Login</h2>
              <h3 className={`title ${theme === "light" ? "text-black" : ""}`}>
                Which account would you like to log in to?
              </h3>
            </div>

            <div className="cateogories_wrapper">
              <div className="cateogory_box">
                <Link
                  to={designAssistantLoginURL}
                  className="chooser_btn chooser_btn--personal"
                >
                  Personal Account
                </Link>
              </div>
              <div className="cateogory_box">
                <a
                  href="https://business.archinza.com/login"
                  className="chooser_btn chooser_btn--business"
                >
                  Business Account
                </a>
              </div>
            </div>
          </div>
        </section>

        {theme === "dark" ? (
          <FooterV2 whatsappBotIcon={false} />
        ) : (
          <FooterV2 lightTheme whatsappBotIcon={false} />
        )}
      </main>
    </>
  );
};
export default Login;
